import { IBannerTypeEnum } from '@r-client/data/graphql-types';

import { IBannerQuery } from '../../graphql/types';
import { ActionRequiredBanner } from '../action-required-banner/action-required-banner';
import { ActiveFlashbarBanner } from '../active-flashbar-banner/active-flashbar-banner';
import { ClosingSoonBanner } from '../closing-soon-banner/closing-soon-banner';
import { IdentityVerificationBanner } from '../identity-verification-banner/identity-verification-banner';
import { TwoFactorReminderBanner } from '../two-factor-reminder-banner/two-factor-reminder-banner';

type TDismissUserBannerHandler = (bannerType: IBannerTypeEnum) => Promise<void>;

// Returns null for banner types we don't render, so callers can tell "nothing to
// show" from "banner to show" (analytics, animation) instead of assuming any
// banner payload means a visible banner.
export function renderBanner(
  banner: IBannerQuery['banner'],
  onDismissUserBanner: TDismissUserBannerHandler
) {
  switch (banner?.__typename) {
    case 'TwoFactorReminderBanner':
      return (
        <TwoFactorReminderBanner
          deadline={banner.deadline}
          onClose={onDismissUserBanner}
        />
      );
    case 'ActionRequiredBanner':
      return <ActionRequiredBanner investment={banner.investment} />;
    case 'ClosingSoonBanner':
      return (
        <ClosingSoonBanner
          offeringClosingFirst={banner.offeringClosingFirst.id}
          offerings={banner.offerings}
          timeLeftInSec={banner.timeLeft}
          onClose={onDismissUserBanner}
        />
      );
    case 'IdentityVerificationBanner':
      return <IdentityVerificationBanner />;
    case 'ActiveFlashbarBanner':
      return <ActiveFlashbarBanner banner={banner} />;
    // Promotional banners are now authored in the CMS and delivered as
    // ActiveFlashbarBanner. The backend union still declares the retired types,
    // so anything we don't render must fall through to nothing — never a
    // placeholder, which would leak a raw __typename to users.
    default:
      return null;
  }
}
